<template>
	<dialog-fullscreen :visibility.sync = 'visibility' :indicator = 'indicator'>
		<template v-slot:title>Создание отчета</template>
		<template v-slot:action>
			<v-btn 
				text 
				:disabled = '!valid'
				:loading = 'indicator'
				color='green darken-2' 
				@click = 'createReport'
			>
                Создать
            </v-btn>
		</template>
		<template v-slot:content>
			<v-form v-model = 'valid' style = 'min-width: 320px; max-width: 420px;'>
				<v-text-field
					v-model = "report.report_name"
					label = "Название отчета"
					:rules = "[rules.required]"
				></v-text-field>
				<v-textarea
					v-model = "report.report_desc"
					label = "Описание отчета"
					:rules = "[rules.required]"
				></v-textarea>
				<template v-if = '!addUserFlow'>
					<v-text-field
						v-model = "report.report_id"
						label = "Идентификатор отчета"
						:rules = "[rules.required]"
						:error = 'errorCreate'
						:error-messages = 'errorCreateMessage'
						@keyup = 'errorCreate=false;errorCreateMessage=[];'
					></v-text-field>
					<v-text-field
						v-model = "report.group_id"
						label="Идентификатор группы отчета"
						:rules = "[rules.required]"
					></v-text-field>
					<v-select
						v-model = "report.is_client"
						label = "Доступность отчета"
						:rules = "[rules.required]"
						:items = " [{ 'value': '0', 'text': 'Внутренний' }, { 'value': '1', 'text': 'Клиентский' }]" 
						item-text="text" 
						item-value="value"
					></v-select>
				</template>
			</v-form>
		</template>
	</dialog-fullscreen>
</template>

<script>
	import DialogFullscreen from '@/components/elements/dialogs/Fullscreen.vue'

	export default {
		name: 'ReportCreateDialog',
		props: ['initialState','flowAdd', 'postAction', 'project'],
		components: {'dialog-fullscreen': DialogFullscreen},
		data() {
			return {
				addUserFlow: this.flowAdd,
				valid: false,
				visibility: this.initialState,
				indicator: false,
				errorCreate: false,
				errorCreateMessage: '',
				report: {
					'project_id': this.project.project_id,
					'group_id': this.project.workspace_id
				},
				rules: {
					required: value => !!value || 'Обязательное поле.'
				}
			}
		},
		watch: {
			initialState (value) {
				this.visibility = value;
			},
			visibility(value) {
	            this.$emit('update:initialState', value);
	        },
	        project() {
	        	this.report.project_id = this.project.project_id,
	        	this.report.group_id = this.project.workspace_id
	        }
		},
		methods: {
			createReport () {
		        this.indicator = true;
		        let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8',
		          'Authorization': 'Bearer ' + String(this.$store.getters.userToken)
		        }
		        let requestData = {
		          'login': this.$store.getters.userLogin
		        }
		        this.$http.post(this.$store.getters.endpoint + '/db/reports', 
		          {...requestData,...this.report},
		          {
		            headers: {...this.$store.state.restrictedHeaders,...requestHeaders}
		          }).then( (r) => {
		            let response = r.body;
		            this.indicator = false;
		            if (response.result) {
						this.postAction('reports')
						this.$dataLayer.$emit('enrich', {
							event: 'crud',
							data: {
								type: 'create',
								target: 'report'
							},
							once: false
						})
		            	this.visibility = false;
		            } else {
		              this.errorCreate = true;
		              this.errorCreateMessage = ['Идентификатор уже используется в другом объекте']
		              console.log(response)
		            }
		        })
		    }
		}
	}
</script>